import { langUrl } from "./i18nConfig";
import en from './lang/en.json';
import th from './lang/th.json';
export function fetchTranslations(lang) {
  if (lang === 'th') {
    return th
  } 
  return en
}
